import React, { useState } from 'react';
import { SmilePlus } from 'lucide-react';

export const REACTIONS = ['👀', '🔥', '❤️', '😂', '👍', '🕵️'];

// Emoji palette used from the hover action bar
export const ReactionPicker = ({ onPick, testId, align = 'right' }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="relative">
      <button onClick={() => setOpen((o) => !o)} className="p-1 rounded hover:bg-zinc-700 hover:text-amber-400" title="React" data-testid={testId}>
        <SmilePlus className="w-3.5 h-3.5" />
      </button>
      {open && (
        <div className={`absolute ${align === 'left' ? 'left-0' : 'right-0'} top-full mt-1 flex gap-0.5 bg-[#18181b] border border-zinc-700 rounded-lg p-1 shadow-xl z-30`} data-testid="reaction-picker" onMouseLeave={() => setOpen(false)}>
          {REACTIONS.map((e) => (
            <button key={e} onClick={() => { onPick(e); setOpen(false); }} className="w-7 h-7 flex items-center justify-center rounded hover:bg-zinc-700 text-base transition-transform hover:scale-125" data-testid={`reaction-pick-${e}`}>{e}</button>
          ))}
        </div>
      )}
    </div>
  );
};

// Counts under a message; tap toggles your own reaction
export const ReactionBar = ({ reactions = {}, meId, onToggle, messageId }) => {
  const entries = Object.entries(reactions).filter(([, users]) => users?.length);
  if (!entries.length) return null;
  return (
    <div className="flex flex-wrap gap-1 mt-1.5" data-testid={`reactions-${messageId}`}>
      {entries.map(([emoji, users]) => {
        const mine = users.includes(meId);
        return (
          <button key={emoji} onClick={() => onToggle(emoji)} data-testid={`reaction-${messageId}-${emoji}`}
            title={mine ? 'Remove your reaction' : 'React'}
            className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full border text-xs font-mono transition-colors ${mine ? 'bg-amber-500/20 border-amber-500/60 text-amber-300' : 'bg-zinc-800/70 border-zinc-700 text-zinc-300 hover:border-zinc-500'}`}>
            <span className="text-sm leading-none">{emoji}</span>
            <span>{users.length}</span>
          </button>
        );
      })}
    </div>
  );
};
